import React, { Component } from 'react';
import NavLink from '../helpers/navlink';

class Navbar extends Component {
  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <span className="navbar-brand">Saskatoon Sexual Health</span>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <NavLink to="/stats">Stats</NavLink>
            <NavLink to="/export">Stats Export</NavLink>
            <NavLink to="/patients">Patients</NavLink>
            <NavLink to="/calendar">Calendar</NavLink>
          </ul>
        </div>
      </nav>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/nav.js